import React, { lazy } from "react";
import PrivateRoutes from "../routes/PrivateRoutes";
import LayoutWrapper from "../HoC/LayoutWrapper";
// import UserManagement from "../modules/super-admin/UserManagement";
const FullConversation = lazy(() => import("../modules/super-admin/ContentManagement/FullConversation"));
const UserManagement = lazy(() => import("../modules/super-admin/UserManagement"));
const Dashboard = lazy(() => import("../modules/super-admin/Dashboard"));
const ToBeVerified = lazy(() =>
  import("../modules/super-admin/toBeVerifiedUser/ShowUsers/index")
);

const ManageContent = lazy(() =>
  import("../modules/super-admin/ContentManagement/ManageContent/Index")
);

const CategoryManagement = lazy(() =>
  import("../modules/super-admin/ContentManagement/CategoryManagement/Index")
);
// AddClinic component was commented out and removed
const Report = lazy(() => import("../modules/super-admin/Reports"));
const ManageForm = lazy(() =>
  import("../modules/super-admin/Forms/ManageForm")
);
const ViewForm = lazy(() => import("../modules/super-admin/Forms/ViewForm"));
const AddForm = lazy(() => import("../modules/super-admin/Forms/AddForm"));
const EditForm = lazy(() => import("../modules/super-admin/Forms/EditForm"));
const AddUser = lazy(() => import("../modules/super-admin/Dashboard/AddUser"));

const ViewUser = lazy(() =>
  import("../modules/super-admin/ContentManagement/ViewUser")
);
const ManageTicket = lazy(() => import("../modules/super-admin/Ticket"));
const Notification = lazy(() =>
  import("../modules/super-admin/AllNotification/Notifications")
);
const Reportss = lazy(() => import("../modules/Report/Reportedlist"));
const Subscription = lazy(() =>
  import("../modules/super-admin/subscription/subscription")
);
const Links = lazy(() => import("../modules/super-admin/Deeplink/links"));
const Quations = lazy(() =>
  import("../modules/super-admin/Quationnaire/addQuation")
);

const PaymentHistory = lazy(() =>
  import("../modules/super-admin/PaymentHistory/paymentHistory")
);

const MostActiveUsers = lazy(() =>
  import("../modules/super-admin/MostActiveUsers")
);
const JobManagement = lazy(() =>
  import("../modules/super-admin/JobManagement")
);

// Master Layout


const AdminRouter = [
  {
    path: "/admin/",
    element: <PrivateRoutes />,
    children: [
      {
        path: "dashboard",
        element: <LayoutWrapper childComponent={<Dashboard />} />,
      },
       {
        path: "usermanagement",
        element: <LayoutWrapper childComponent={<UserManagement />} />,
      },
       {
        path: "MostActiveUsers",
        element: <LayoutWrapper childComponent={<MostActiveUsers />} />,
      },
      {
        path: "content-management",
        element: <LayoutWrapper childComponent={<ManageContent />} />,
      },
      {
        path: "category/:id",
        element: <LayoutWrapper childComponent={<CategoryManagement />} />,
      },
      {
        path: "dashboard/view",
        element: <LayoutWrapper childComponent={<ViewUser />} />,
      },
      {
        path: "dashboard/fullconversation",
        element: <LayoutWrapper childComponent={<FullConversation />} />,
      },
      {
        path: "reports",
        element: <LayoutWrapper childComponent={<Report />} />,
      },
      {
        path: "forms",
        element: <LayoutWrapper childComponent={<ManageForm />} />,
      },
      {
        path: "forms/add/",
        element: <LayoutWrapper childComponent={<AddForm />} />,
      },
      {
        path: "forms/edit/:id/:el",
        element: <LayoutWrapper childComponent={<EditForm />} />,
      },
      {
        path: "dashboard/view/portfolio/:id",
        element: <LayoutWrapper childComponent={<ViewForm />} />,
      },
      {
        path: "user/tobeverifed/",
        element: <LayoutWrapper childComponent={<ToBeVerified />} />,
      },
      {
        path: "notifications",
        element: <LayoutWrapper childComponent={<Notification />} />,
      },
      {
        path: "report",
        element: <LayoutWrapper childComponent={<Reportss />} />,
      },
      {
        path: "subscription",
        element: <LayoutWrapper childComponent={<Subscription />} />,
      },
      {
        path: "send-notification",
        element: <LayoutWrapper childComponent={<Links />} />,
      },
      {
        path: "questionnaire-management",
        element: <LayoutWrapper childComponent={<Quations />} />,
      },
      {
        path: "payment/history",
        element: <LayoutWrapper childComponent={<PaymentHistory />} />,
      },
      {
        path: "job-management",
        element: <LayoutWrapper childComponent={<JobManagement />} />,
      },
    ],
  },
];

export default AdminRouter;

// {
//   path: "dashboard/add/user",
//   element: <LayoutWrapper childComponent={<AddUser />} />,
// },
